import React from "react";
import PropTypes from "prop-types";
import { Card, Row, Col } from "antd";
//import jMoment from "moment-jalaali";
import jMoment from "components/classes/Jmomen";
import Month from "./Month";

@autobind
/**
 *
 */
export default class Year extends React.PureComponent {
  static propTypes = {
    year: PropTypes.number,
    selected: PropTypes.arrayOf(
      PropTypes.shape({
        start: PropTypes.string,
        end: PropTypes.string,
      })
    ),
    start: PropTypes.string,
    disabled: PropTypes.func,
    onMonthClick: PropTypes.func,
    onWeekDayClick: PropTypes.func,
    onMouseDown: PropTypes.func,
    onMouseUp: PropTypes.func,
    events: PropTypes.arrayOf(
      PropTypes.shape({
        date: PropTypes.string,
        color: PropTypes.string,
        content: PropTypes.string,
      })
    ),
    statuses: PropTypes.arrayOf(
      PropTypes.shape({
        date: PropTypes.string,
        color: PropTypes.string,
        title: PropTypes.string,
        description: PropTypes.string,
      })
    ),
  };

  static defaultProps = {
    year: jMoment().jYear(),
    disabled: () => {},
    onMonthClick: () => {},
    onWeekDayClick: () => {},
    onMouseDown: () => {},
    onMouseUp: () => {},
    selected: [],
    events: [],
    statuses: [],
    start: null,
  };

  /**
   *
   * @param {String} year
   * @return {*}
   * @private
   */
  _holidays(year) {
    const statuses = this.props.statuses;

    const _statuses = statuses;

    const shamsi = {
      "01-01": "جشن نوروز/جشن سال نو",
      "01-02": "عیدنوروز",
      "01-03": "عیدنوروز",
      "01-04": "عیدنوروز",
      "01-12": "روز جمهوری اسلامی ایران",
      "01-13": "جشن سیزده به در",
      "03-14": "رحلت حضرت امام خمینی",
      "03-15": "قیام 15 خرداد",
      "11-22": "",
      "12-29": "روز ملی شدن صنعت نفت ایران",
    };
    const kabise = {
      "12-30": "آخرین روز سال",
    };
    // const ghamari = {
    //   "01-09": "تاسوعای حسینی",
    //   "01-10": "عاشورای حسینی",
    //   "02-20": "اربعین حسینی",
    //   "02-28": "رحلت رسول اکرم؛شهادت امام حسن مجتبی علیه السلام",
    //   "02-30": "شهادت امام رضا علیه السلام",
    //   "03-08": "شهادت امام حسن عسکری علیه السلام",
    //   "03-17": "میلاد رسول اکرم و امام جعفر صادق علیه السلام",
    //   "07-13": "ولادت امام علی علیه السلام و روز پدر",
    //   "07-27": "مبعث رسول اکرم",
    //   "08-15": "ولادت حضرت قائم عجل الله تعالی فرجه و جشن نیمه شعبان",
    //   "09-21": "شهادت حضرت علی علیه السلام",
    //   "10-01": "عید سعید فطر",
    //   "10-02": "تعطیل به مناسبت عید سعید فطر",
    //   "10-25": "شهادت امام جعفر صادق علیه السلام",
    //   "12-10": "عید سعید قربان",
    //   "12-18": "عید سعید غدیر خم",
    // };
    const ramezan = {
      1390: ["05-10", "06-08"],
      1391: ["04-31", "05-28"],
      1392: ["04-19", "05-28"],
      1393: ["04-08", "05-06"],
      1394: ["03-28", "04-26"],
      1395: ["03-18", "04-15"],
      1396: ["03-06", "04-06"],
      1397: ["02-27", "03-26"],
      1398: ["02-16", "03-13"],
      1399: ["02-05", "03-03"],
      1400: ["01-25", "02-22"],
      1401: ["01-13", "02-11"],
      1402: ["01-03", "01-31"],
    };
    const ghamari = {
      1390: {
        "09-14": "تاسوعای حسینی",
        "09-15": "عاشورای حسینی",
        "10-24": "اربعین حسینی",
        "11-02": "رحلت رسول اکرم؛شهادت امام حسن مجتبی علیه السلام",
        "11-04": "شهادت امام رضا علیه السلام",
        "11-12": "شهادت امام حسن عسکری علیه السلام",
        "11-21": "میلاد رسول اکرم و امام جعفر صادق علیه السلام",
        "02-17": "شهادت حضرت فاطمه زهرا سلام الله علیها",
        "03-26": "ولادت امام علی علیه السلام و روز پدر",
        "04-09": "مبعث رسول اکرم",
        "04-26": "ولادت حضرت قائم عجل الله تعالی فرجه و جشن نیمه شعبان",
        "05-30": "شهادت حضرت علی علیه السلام",
        "06-09": "عید سعید فطر",
        "06-10": "تعطیل به مناسبت عید سعید فطر",
        "07-02": "شهادت امام جعفر صادق علیه السلام",
        "08-16": "عید سعید قربان",
        "08-24": "عید سعید غدیر خم",
      },
      1391: {
        "09-04": "تاسوعای حسینی",
        "09-05": "عاشورای حسینی",
        "10-14": "اربعین حسینی",
        "10-22": "رحلت رسول اکرم؛شهادت امام حسن مجتبی علیه السلام",
        "10-23": "شهادت امام رضا علیه السلام",
        "11-01": "شهادت امام حسن عسکری علیه السلام",
        "11-10": "میلاد رسول اکرم و امام جعفر صادق علیه السلام",
        "02-06": "شهادت حضرت فاطمه زهرا سلام الله علیها",
        "03-15": "ولادت امام علی علیه السلام و روز پدر",
        "03-29": "مبعث رسول اکرم",
        "04-15": "ولادت حضرت قائم عجل الله تعالی فرجه و جشن نیمه شعبان",
        "05-20": "شهادت حضرت علی علیه السلام",
        "05-29": "عید سعید فطر",
        "05-30": "تعطیل به مناسبت عید سعید فطر",
        "06-22": "شهادت امام جعفر صادق علیه السلام",
        "08-05": "عید سعید قربان",
        "08-13": "عید سعید غدیر خم",
      },
      1392: {
        "08-22": "تاسوعای حسینی",
        "08-23": "عاشورای حسینی",
        "10-02": "اربعین حسینی",
        "10-10": "رحلت رسول اکرم؛شهادت امام حسن مجتبی علیه السلام",
        "10-12": "شهادت امام رضا علیه السلام",
        "10-20": "شهادت امام حسن عسکری علیه السلام",
        "10-29": "میلاد رسول اکرم و امام جعفر صادق علیه السلام",
        "01-25": "شهادت حضرت فاطمه زهرا سلام الله علیها",
        "02-03": "ولادت امام علی علیه السلام و روز پدر",
        "02-17": "مبعث رسول اکرم",
        "01-03": "ولادت حضرت قائم عجل الله تعالی فرجه و جشن نیمه شعبان",
        "05-08": "شهادت حضرت علی علیه السلام",
        "05-18": "عید سعید فطر",
        "05-19": "تعطیل به مناسبت عید سعید فطر",
        "06-11": "شهادت امام جعفر صادق علیه السلام",
        "07-24": "عید سعید قربان",
        "08-02": "عید سعید غدیر خم",
      },
      1393: {
        "08-12": "تاسوعای حسینی",
        "08-13": "عاشورای حسینی",
        "09-22": "اربعین حسینی",
        "09-30": "رحلت رسول اکرم؛شهادت امام حسن مجتبی علیه السلام",
        "10-02": "شهادت امام رضا علیه السلام",
        "10-10": "شهادت امام حسن عسکری علیه السلام",
        "10-19": "میلاد رسول اکرم و امام جعفر صادق علیه السلام",
        "01-14": "شهادت حضرت فاطمه زهرا سلام الله علیها",
        "02-23": "ولادت امام علی علیه السلام و روز پدر",
        "03-06": "مبعث رسول اکرم",
        "03-23": "ولادت حضرت قائم عجل الله تعالی فرجه و جشن نیمه شعبان",
        "04-28": "شهادت حضرت علی علیه السلام",
        "05-07": "عید سعید فطر",
        "05-08": "تعطیل به مناسبت عید سعید فطر",
        "05-31": "شهادت امام جعفر صادق علیه السلام",
        "07-13": "عید سعید قربان",
        "07-21": "عید سعید غدیر خم",
      },
      1394: {
        "08-01": "تاسوعای حسینی",
        "08-02": "عاشورای حسینی",
        "09-11": "اربعین حسینی",
        "09-19": "رحلت رسول اکرم؛شهادت امام حسن مجتبی علیه السلام",
        "09-21": "شهادت امام رضا علیه السلام",
        "09-29": "شهادت امام حسن عسکری علیه السلام",
        "10-08": "میلاد رسول اکرم و امام جعفر صادق علیه السلام",
        "12-23": "شهادت حضرت فاطمه زهرا سلام الله علیها",
        "01-04": "شهادت حضرت فاطمه زهرا سلام الله علیها",
        "02-12": "ولادت امام علی علیه السلام و روز پدر",
        "02-26": "مبعث رسول اکرم",
        "03-13": "ولادت حضرت قائم عجل الله تعالی فرجه و جشن نیمه شعبان",
        "04-17": "شهادت حضرت علی علیه السلام",
        "04-27": "عید سعید فطر",
        "04-28": "تعطیل به مناسبت عید سعید فطر",
        "05-20": "شهادت امام جعفر صادق علیه السلام",
        "07-02": "عید سعید قربان",
        "07-10": "عید سعید غدیر خم",
      },
      1395: {
        "07-20": "تاسوعای حسینی",
        "07-21": "عاشورای حسینی",
        "08-30": "اربعین حسینی",
        "09-08": "رحلت رسول اکرم؛شهادت امام حسن مجتبی علیه السلام",
        "09-10": "شهادت امام رضا علیه السلام",
        "09-18": "شهادت امام حسن عسکری علیه السلام",
        "09-27": "میلاد رسول اکرم و امام جعفر صادق علیه السلام",
        "12-12": "شهادت حضرت فاطمه زهرا سلام الله علیها",
        "02-02": "ولادت امام علی علیه السلام و روز پدر",
        "02-16": "مبعث رسول اکرم",
        "03-02": "ولادت حضرت قائم عجل الله تعالی فرجه و جشن نیمه شعبان",
        "04-07": "شهادت حضرت علی علیه السلام",
        "04-16": "عید سعید فطر",
        "04-17": "تعطیل به مناسبت عید سعید فطر",
        "05-09": "شهادت امام جعفر صادق علیه السلام",
        "06-22": "عید سعید قربان",
        "06-30": "عید سعید غدیر خم",
      },
      1396: {
        "07-08": "تاسوعای حسینی",
        "07-09": "عاشورای حسینی",
        "08-18": "اربعین حسینی",
        "08-26": "رحلت رسول اکرم؛شهادت امام حسن مجتبی علیه السلام",
        "08-28": "شهادت امام رضا علیه السلام",
        "09-06": "شهادت امام حسن عسکری علیه السلام",
        "09-15": "میلاد رسول اکرم و امام جعفر صادق علیه السلام",
        "12-01": "شهادت حضرت فاطمه زهرا سلام الله علیها",
        "01-22": "ولادت امام علی علیه السلام و روز پدر",
        "02-05": "مبعث رسول اکرم",
        "02-22": "ولادت حضرت قائم عجل الله تعالی فرجه و جشن نیمه شعبان",
        "03-26": "شهادت حضرت علی علیه السلام",
        "04-05": "عید سعید فطر",
        "04-06": "تعطیل به مناسبت عید سعید فطر",
        "04-29": "شهادت امام جعفر صادق علیه السلام",
        "06-10": "عید سعید قربان",
        "06-18": "عید سعید غدیر خم",
      },
      1397: {
        "01-01": "عید نوروز - شهادت حضرت امام علی النقی الهادی علیه السلام",
        "01-02": "عید نوروز",
        "01-03": "عید نوروز",
        "01-04": "عید نوروز",
        "01-11": "ولادت امام علی علیه السلام و روز پدر",
        "01-12": "روز جمهوری اسلامی ایران",
        "01-13": "روز طبیعت - وفات حضرت زینب سلام الله علیها",
        "01-25": "مبعث رسول اکرم",
        "02-12": "ولادت حضرت قائم عجل الله تعالی فرجه و جشن نیمه شعبان",
        "03-14": "رحلت حضرت امام خمینی (رحمه الله علیه)",
        "03-15": "قیام خونین ۱۵ خرداد",
        "03-16": "شهادت حضرت علی علیه السلام",
        "03-25": "عید سعید فطر",
        "03-26": "تعطیل به مناسبت عید سعید فطر",
        "04-18": "شهادت امام جعفر صادق علیه السلام",
        "05-31": "عید سعید قربان",
        "06-08": "عید سعید غدیر خم",
        "06-28": "تاسوعای حسینی",
        "06-29": "عاشورای حسینی",
        "08-08": "اربعین حسینی",
        "08-16":
          "رحلت حضرت رسول اکرم صلی الله علیه و آله - شهادت امام حسن مجتبی علیه السلام - ",
        "08-17": "شهادت امام رضا علیه السلام",
        "08-25": "شهادت امام حسن عسکری علیه السلام",
        "09-04": "میلاد رسول اکرم و امام جعفر صادق علیه السلام",
        "11-20": "شهادت حضرت فاطمه زهرا سلام الله علیها",
        "11-22": " ایران",
        "12-29":
          "ولادت حضرت امام علی علیه السلام و روز پدر -روز ملی شدن صنعت نفت ایران",
      },
      1398: {
        "01-01": "عید نوروز",
        "01-02": "عید نوروز - ارتحال حضرت زینب(س)",
        "01-03": "عید نوروز",
        "01-04": "عید نوروز",
        "01-12": "روز جمهوری اسلامی ایران",
        "01-14": "مبعث حضرت رسول اکرم(ص)",
        "02-01": "ولادت حضرت قائم عجل الله تعالی فرجه و جشن نیمه شعبان",
        "03-05": "شهادت حضرت علی علیه السلام",
        "03-14":
          "رحلت حضرت امام خمینی(ره) و آغاز ولایت آیت االله امام خامنه‌ای",
        "03-15": "عید سعید فطر - قیام ۱۵خرداد",
        "03-16": "تعطیل به مناسبت عید سعید فطر",
        "04-08": "شهادت امام جعفر صادق علیه السلام",
        "05-21": "عید سعید قربان",
        "05-29": "عید سعید غدیر خم",
        "06-18": "تاسوعای حسینی",
        "06-19": "عاشورای حسینی",
        "07-27": "اربعین حسینی",
        "08-05": "رحلت رسول اکرم؛شهادت امام حسن مجتبی علیه السلام",
        "08-07": "شهادت امام رضا علیه السلام",
        "08-15": "شهادت امام حسن عسکری علیه السلام",
        "08-24":
          "ولادت حضرت رسول اکرم(ص) و روز اخلاق و مهرورزی - ولادت حضرت امام جعفر صادق علیه السلام ",
        "11-09": "شهادت حضرت فاطمه زهرا سلام الله علیها",
        "11-22": "پیروزی شکوهمند انقلاب اسلامی",
        "12-18": "ولادت امام علی علیه السلام و روز پدر",
        "12-29": "روز ملی شدن صنعت نفت ایران",
      },
      1399: {
        "01-01": "عید نوروز",
        "01-02": "عید نوروز",
        "01-03": "عید نوروز",
        "01-04": "عید نوروز",
        "01-12": "روز جمهوری اسلامی ایران",
        "01-13": "روز طبیعت",
        "01-21": "ولادت حضرت قائم عجل الله تعالی فرجه و جشن نیمه شعبان",
        "02-26": "شهادت حضرت علی علیه السلام",
        "03-04": "عید سعید فطر",
        "03-05": "تعطیل به مناسبت عید سعید فطر",
        "03-14": "رحلت حضرت امام خمینی(ره) و آغاز ولایت آیت‌الله امام خامنه‌ای",
        "03-15": "قیام ۱۵ خرداد",
        "03-28": "شهادت امام جعفر صادق علیه السلام",
        "05-10": "عید سعید قربان",
        "05-18": "عید سعید غدیر خم",
        "06-08": "تاسوعای حسینی",
        "06-09": "عاشورای حسینی",
        "07-17": "اربعین حسینی",
        "07-25": "رحلت رسول اکرم؛شهادت امام حسن مجتبی علیه السلام",
        "07-26": "شهادت امام رضا علیه السلام",
        "08-04": "شهادت امام حسن عسکری علیه السلام",
        "08-13": "میلاد رسول اکرم و امام جعفر صادق علیه السلام",
        "10-28": "شهادت حضرت فاطمه زهرا سلام الله علیها",
        "12-07": "ولادت امام علی علیه السلام و روز پدر",
        "12-21": "مبعث رسول اکرم",
        "12-29": "ولادت امام سجاد علیه السلام-روز ملی شدن صنعت نفت ایران ",
      },
      1400: {
        "01-01": "عید نوروز",
        "01-02": "عید نوروز",
        "01-03": "عید نوروز",
        "01-04": "عید نوروز",
        "01-09": "ولادت حضرت قائم عجل الله تعالی فرجه و جشن نیمه شعبان",
        "01-12": "روز جمهوری اسلامی ایران",
        "01-13": "جشن سیزده به در",
        "02-14": "شهادت حضرت علی علیه السلام",
        "02-23": "عید سعید فطر",
        "02-24": "تعطیل به مناسبت عید سعید فطر",
        "03-14": "حلت حضرت امام خمینی",
        "03-15": "قیام 15 خرداد",
        "03-16": "شهادت امام جعفر صادق علیه السلام",
        "04-30": "عید سعید قربان",
        "05-07": "عید سعید غدیر خم",
        "05-27": "تاسوعای حسینی",
        "05-28": "عاشورای حسینی",
        "07-05": "اربعین حسینی",
        "07-13": "رحلت رسول اکرم؛شهادت امام حسن مجتبی علیه السلام",
        "07-15": "شهادت امام رضا علیه السلام",
        "07-23": "شهادت امام حسن عسکری علیه السلام",
        "08-02": "میلاد رسول اکرم و امام جعفر صادق علیه السلام",
        "10-16": "شهادت حضرت فاطمه زهرا سلام الله علیها",
        "11-22": "",
        "11-26": "ولادت امام علی علیه السلام و روز پدر",
        "12-10": "مبعث رسول اکرم",
        "12-27": "ولادت حضرت قائم عجل الله تعالی فرجه و جشن نیمه شعبان",
        "12-29": "روز ملی شدن صنعت نفت ایران",
      },
      1401: {
        "01-01": "عید نوروز",
        "01-02": "عید نوروز",
        "01-03": "عید نوروز",
        "01-04": "عید نوروز",
        "01-12": "روز جمهوری اسلامی ایران",
        "01-13": "جشن سیزده به در",
        "02-03": "شهادت حضرت علی علیه السلام ",
        "02-13": "عید سعید فطر",
        "02-14": "عید سعید فطر",
        "03-06": "شهادت امام جعفر صادق علیه السلام ",
        "03-14": "رحلت حضرت امام خمینی",
        "03-15": "قیام 15 خرداد",
        "04-19": "عید سعید قربان",
        "04-27": "عید سعید غدیر خم",
        "05-16": "تاسوعای حسینی",
        "05-17": "عاشورای حسینی",
        "06-26": "اربعین حسینی",
        "07-03": "رحلت رسول اکرم؛شهادت امام حسن مجتبی علیه السلام",
        "07-05": "شهادت امام رضا علیه السلام",
        "07-13": " شهادت امام حسن عسکری علیه السلام ",
        "07-22": "میلاد رسول اکرم و امام جعفر صادق علیه السلام",
        "10-06": "شهادت حضرت فاطمه زهرا سلام الله علیها",
        "11-15": "ولادت امام علی علیه السلام و روز پدر",
        "11-22": "",
        "11-29": "مبعث رسول اکرم",
        "12-17": "ولادت حضرت قائم عجل الله تعالی فرجه و جشن نیمه شعبان",
        "12-29": "روز ملی شدن صنعت نفت ایران",
      },
      1402: {
        "01-01": "عید نوروز",
        "01-02": "عید نوروز",
        "01-03": "عید نوروز",
        "01-04": "عید نوروز",
        "01-12": "روز جمهوری اسلامی ایران",
        "01-13": "جشن سیزده به در",
        "01-23": "شهادت حضرت علی علیه السلام ",
        "02-02": "عید سعید فطر",
        "02-03": "عید سعید فطر",
        "02-26": "شهادت امام جعفر صادق علیه السلام",
        "03-14": "رحلت حضرت امام خمینی",
        "03-15": "قیام 15 خرداد",
        "04-08": "عید سعید قربان",
        "04-16": "عید سعید غدیر خم",
        "05-05": "تاسوعای حسینی",
        "05-06": "عاشورای حسینی",
        "06-15": "اربعین حسینی",
        "06-23": "رحلت رسول اکرم؛شهادت امام حسن مجتبی علیه السلام",
        "06-25": "شهادت امام رضا علیه السلام",
        "07-02": "شهادت امام حسن عسکری علیه السلام ",
        "07-11": "میلاد رسول اکرم و امام جعفر صادق علیه السلام ",
        "09-26": "شهادت حضرت فاطمه زهرا سلام الله علیها ",
        "11-05": "ولادت امام علی علیه السلام و روز پدر",
        "11-19": "مبعث رسول اکرم",
        "11-22": "",
        "12-06": "ولادت حضرت قائم عجل الله تعالی فرجه و جشن نیمه شعبان",
        "12-29": "روز ملی شدن صنعت نفت ایران",
      },
      1403: {
        "01-01": "عید نوروز",
        "01-02": "عید نوروز",
        "01-03": "عید نوروز",
        "01-04": "عید نوروز",
        "01-12": "روز جمهوری اسلامی ایران",
        "01-13": "جشن سیزده به در",
        "01-13": "شهادت حضرت علی علیه السلام ",
        "01-22": "عید سعید فطر",
        "01-23": "عید سعید ",
        "02-15": "شهادت امام جعفر صادق علیه السلام",
        "03-14": "رحلت حضرت امام خمینی",
        "03-15": "قیام 15 خرداد",
        "03-28": "عید سعید قربان",
        "04-05": "عید سعید غدیر خم",
        "04-25": "تاسوعای حسینی",
        "04-26": "عاشورای حسینی",
        "06-04": "اربعین حسینی",
        "06-12": "رحلت رسول اکرم؛شهادت امام حسن مجتبی علیه السلام",
        "06-14": "شهادت امام رضا علیه السلام",
        "06-22": "شهادت امام حسن عسکری علیه السلام ",
        "06-31": "میلاد رسول اکرم و امام جعفر صادق علیه السلام ",
        "09-15": "شهادت حضرت فاطمه زهرا سلام الله علیها ",
        "10-25": "ولادت امام علی علیه السلام و روز پدر",
        "11-09": "مبعث رسول اکرم",
        "11-22": "",
        "11-26": "ولادت حضرت قائم عجل الله تعالی فرجه و جشن نیمه شعبان",
        "12-29": "روز ملی شدن صنعت نفت ایران",
        "12-30": "روز آخر سال ",
      },
      1404: {
        "01-01": "عید نوروز",
        "01-02": "عید نوروز",
        "01-02": "شهادت حضرت علی علیه السلام",
        "01-03": "عید نوروز",
        "01-04": "عید نوروز",
        "01-11": "عید سعید فطر",
        "01-12": " روز جمهوری اسلامی",
        "01-13": "تعطیل به مناسبت عید سعید فطر",
        "01-13": "جشن سیزده به در",
        "02-04": "شهادت امام جعفر صادق علیه السلام",
        "03-14": "رحلت حضرت امام خمینی",
        "03-15": "قیام 15 خرداد",
        "03-16": "عید سعید قربان",
        "03-24": "عید سعید غدیر خم [ ١٨ ذوالحجه ]",
        "04-14": "تاسوعای حسینی",
        "04-15": "عاشورای حسینی",
        "05-23": "اربعین حسینی",
        "05-31": "رحلت رسول اکرم؛شهادت امام حسن مجتبی علیه السلام",
        "06-02": "شهادت امام رضا علیه السلام",
        "06-10": "شهادت امام حسن عسکری علیه السلام ",
        "06-19": "میلاد رسول اکرم و امام جعفر صادق علیه السلام ",
        "09-03": "شهادت حضرت فاطمه زهرا سلام الله علیها ",
        "10-13": "ولادت امام علی علیه السلام و روز پدر",
        "10-27": "مبعث رسول اکرم",
        "11-15": "ولادت حضرت قائم عجل الله تعالی فرجه و جشن نیمه شعبان",
        "11-22": "",
        "12-20": "شهادت حضرت علی علیه السلام",
        "12-29": "روز ملی شدن صنعت نفت ایران",
      },
      1405: {
        "01-01": "عید سعید فطر و عید نوروز",
        "01-02": "عید نوروز",
        "01-02": "شهادت حضرت علی علیه السلام",
        "01-03": "عید نوروز",
        "01-04": "عید نوروز",
        "01-12": " روز جمهوری اسلامی",
        "01-13": "تعطیل به مناسبت عید سعید فطر",
        "01-13": "جشن سیزده به در",
        "01-25": "شهادت امام جعفر صادق (ع)",
        "03-06": "عید سعید قربان",
        "03-14": "عید سعید غدیر خم [ ١٨ ذوالحجه ]",
        "03-15": "قیام 15 خرداد",
        "04-03": "تاسوعای حسینی",
        "04-04": "عاشورای حسینی",
        "05-13": "اربعین حسینی",
        "05-21": "رحلت رسول اکرم؛شهادت امام حسن مجتبی علیه السلام",
        "05-22": "شهادت امام رضا علیه السلام",
        "05-30": "شهادت امام حسن عسکری علیه السلام ",
        "06-08": "میلاد رسول اکرم و امام جعفر صادق علیه السلام ",
        "08-22": "شهادت حضرت فاطمه زهرا سلام الله علیها ",
        "10-02": "ولادت امام علی علیه السلام و روز پدر",
        "10-16": "مبعث رسول اکرم",
        "11-04": "ولادت حضرت قائم عجل الله تعالی فرجه و جشن نیمه شعبان",
        "11-22": "",
        "12-09": "شهادت حضرت علی علیه السلام",
        "12-19": "عید سعید فطر",
        "12-20": "تعطیل به مناسبت عید سعید فطر",
        "12-29": "روز ملی شدن صنعت نفت ایران",
      },
      1406: {
        "01-01": "عید نوروز",
        "01-02": "عید نوروز",
        "01-02": "شهادت حضرت علی علیه السلام",
        "01-03": "عید نوروز",
        "01-04": "عید نوروز",
        "01-12": " روز جمهوری اسلامی",
        "01-13": "تعطیل به مناسبت عید سعید فطر",
        "01-13": "جشن سیزده به در",
        "01-14": "شهادت امام جعفر صادق علیه السلام",
        "02-27": "عید سعید قربان",       
        "03-04": "عید سعید غدیر خم [ ١٨ ذوالحجه ]",
        "03-14": "رحلت حضرت امام خمینی",
        "03-15": "قیام 15 خرداد",
        "03-25": "تاسوعای حسینی",
        "03-26": "عاشورای حسینی",
        "05-03": "اربعین حسینی",
        "05-11": "رحلت رسول اکرم؛شهادت امام حسن مجتبی علیه السلام",
        "05-12": "شهادت امام رضا علیه السلام",
        "05-20": "شهادت امام حسن عسکری علیه السلام ",
        "05-29": "میلاد رسول اکرم و امام جعفر صادق علیه السلام ",
        "08-12": "شهادت حضرت فاطمه زهرا سلام الله علیها ",
        "09-21": "ولادت امام علی علیه السلام و روز پدر",
        "10-05": "مبعث رسول اکرم",
        "10-23": "ولادت حضرت قائم عجل الله تعالی فرجه و جشن نیمه شعبان",
        "11-29": "شهادت حضرت علی علیه السلام",
        "12-08": "عید سعید فطر",
        "12-09": "تعطیل به مناسبت عید سعید فطر",
        "12-29": "روز ملی شدن صنعت نفت ایران",
      },
    };

    const dates = [];

    //
    // if (ramezan[year]) {
    //   let day = `${year}-${ramezan[year][0]}`;
    //   for (let i = 0; i < 31; i++) {
    //     if (day === `${year}-${ramezan[year][1]}`) {
    //       break;
    //     }
    //     _statuses.push({
    //       calendarDayTypeId: 5,
    //       date: day,
    //       description: "ماه رمضان",
    //       color: "#00cccc",
    //       title: "ماه رمضان",
    //     });
    //     day = jMoment(day, "jYYYY-jMM-jDD").add(1, "days").format("jYYYY-jMM-jDD");
    //   }
    // }

    shamsi.$forEach((description, day) => {
      dates.push({ day: `${year}-${day}`, description: description });
    });
    if ((year + 1) % 4 === 0) {
      kabise.$forEach((description, day) => {
        dates.push({ day: `${year}-${day}`, description: description });
      });
    }

    if (ghamari[year]) {
      ghamari[year].$forEach((description, day) => {
        dates.push({
          day: `${year}-${day}`,
          description: description,
        });
      });
    }

    if (ramezan[year]) {
      let day = `${year}-${ramezan[year][0]}`;
      for (let i = 0; i < 31; i++) {
        if (day === `${year}-${ramezan[year][1]}`) {
          break;
        }
        let index = statuses.findIndex((status) => status.date === day);
        if (index > -1) {
          statuses[index] = Object.assign({}, statuses[index], {
            calendarDayTypeId: 5,
            date: day,
            description: "ماه رمضان",
            color: "#00cccc",
            title: "ماه رمضان",
            static: true,
          });
        } else {
          _statuses.push({
            calendarDayTypeId: 5,
            date: day,
            description: "ماه رمضان",
            color: "#00cccc",
            title: "ماه رمضان",
            static: true,
          });
        }
        day = jMoment(day, "jYYYY-jMM-jDD")
          .add(1, "days")
          .format("jYYYY-jMM-jDD");
      }
    }

    dates.forEach((date) => {
      let index = statuses.findIndex(
        (status) => status.date === date.day.toString()
      );
      if (index > -1) {
        statuses[index] = Object.assign({}, statuses[index], {
          calendarDayTypeId: 2,
          date: date.day,
          description: date.description,
          color: "#cc0000",
          title: "روز تعطیل رسمی",
        });
      } else {
        _statuses.push({
          calendarDayTypeId: 2,
          date: date.day,
          description: date.description,
          color: "#cc0000",
          title: "روز تعطیل رسمی",
        });
      }
    });

    return _statuses;
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const {
      year,
      events,
      onMonthClick,
      onWeekDayClick,
      onMouseDown,
      onMouseUp,
      start,
      selected,
      disabled,
      multiEvent,
    } = this.props;

    return (
      <Card>
        <Row>
          {Array.range(11).map((month) => (
            <Col
              key={`month-${month + 1}`}
              xs={24}
              sm={12}
              md={8}
              style={{
                marginTop: 16,
              }}
            >
              <Month
                year={year}
                month={month}
                events={events}
                statuses={this._holidays(year)}
                onMonthClick={onMonthClick}
                onWeekDayClick={onWeekDayClick}
                onMouseDown={onMouseDown}
                onMouseUp={onMouseUp}
                selected={selected}
                start={start}
                disabled={disabled}
                multiEvents={multiEvent}
              />
            </Col>
          ))}
        </Row>
      </Card>
    );
  }
}
